import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * I18n Literals value object
 * */
export default class I18nLiteralsValueObject extends ValueObject {
  constructor({literals} = {}) {
    super({literals})
    this._literals = literals
  }

  /**
   * @return {Object} dictionary with all literals in all languages
   */
  toJSON() {
    return this._literals
  }
}
